
import NewCareerCta from '~/components/navigation/NewCareerCta.vue';
import AboutIntro from '~/components/page-components/aboutpage/AboutIntro.vue';
import AboutIntroSlideshow from '~/components/page-components/aboutpage/AboutIntroSlideshow.vue';
import PromotionTabs from '~/components/page-components/aboutpage/PromotionTabs.vue';
import TextBlocks from '~/components/page-components/aboutpage/TextBlocks.vue';
import TrustElements from '~/components/page-components/aboutpage/TrustElements.vue';
import IconArrowRight from '~/components/icons/IconArrowRight.vue';

export default {
  components: { AboutIntro, TextBlocks, TrustElements, NewCareerCta, AboutIntroSlideshow, PromotionTabs, IconArrowRight },
  mounted () {
    this.$store.commit('closeMenu');
  }

};
